import { trpc } from '@/client/utils/trpc';
import { ProjectRow } from './ProjectRow';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

interface PersonOverviewTabProps {
  person: Employee;
}

export function PersonOverviewTab({ person }: PersonOverviewTabProps) {
  const { data: projects = [], isLoading } = trpc.employees.getProjects.useQuery(
    { id: person.id },
    { enabled: !!person.id },
  );

  return (
    <div className="grid grid-cols-[1.4fr_1fr] gap-4">
      {/* Assigned projects */}
      <div className="rounded-lg border">
        <div className="border-b px-5 py-4">
          <h3 className="text-sm font-semibold">Assigned projects</h3>
        </div>
        <div>
          {isLoading && <p className="p-8 text-center text-sm text-muted-foreground">Loading…</p>}
          {!isLoading && projects.length === 0 && (
            <p className="p-8 text-center text-sm text-muted-foreground">No projects assigned.</p>
          )}
          {projects.map((p, i) => (
            <ProjectRow key={p.id} project={p} isLast={i === projects.length - 1} compact />
          ))}
        </div>
      </div>

      {/* Personal info */}
      <div className="rounded-lg border">
        <div className="border-b px-5 py-4">
          <h3 className="text-sm font-semibold">Personal</h3>
        </div>
        <div className="flex flex-col gap-3.5 p-5">
          {(
            [
              ['Email', person.email],
              ['Role', person.role],
              ['Job title', person.job_title ?? '—'],
              ['Rate', person.rate != null ? `${person.rate} / ${person.rate_type}` : '—'],
              ['Joined', new Date(person.created_at).toLocaleDateString('en-GB')],
            ] as [string, string][]
          ).map(([label, value]) => (
            <div key={label} className="flex justify-between text-sm">
              <span className="text-muted-foreground">{label}</span>
              <span className="font-medium">{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
